import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { getAllUsers } from "../../api/getAllUser";
import { getAllDietTemplate } from "../../api/createDiet";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DietPlanModal.css";
import moment from "moment";

const DietPlanModal = ({ users, show, handleClose, handleSubmit }) => {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);
  const [startDate, setStartDate] = useState(currentDate);
  const [endDate, setEndDate] = useState(currentDate);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState([]);
  const [userId, setUserId] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [allUsers, setAllUsers] = useState(users || []);
  const [allDietTemplate, setAllDietTemplate] = useState([]);
  const [allDietTemplateSelectOptions, setAllDietTemplateSelectOptions] = useState([]);
  const [selectedDietTemplateOptions, setSelectedDietTemplateOptions] = useState([]);
  const [textContent, setTextContent] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const [ templates] = await Promise.all([ getAllDietTemplate()]);
        setAllDietTemplate(templates);
        setAllDietTemplateSelectOptions(templates.map(item => ({ label: item.title, value: item._id })));
      } catch (error) {
        console.error(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);
  

  const closeModal = () => {
    handleClose();
    setTitle("");
    setStartDate(null);
    setEndDate(null);
    setUserId([]);
    setContent([]);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!title.trim()) {
      newErrors.title = "Title is required";
    }

    if (!startDate || !endDate) {
      newErrors.dateRange = "Start and end dates are required";
    }

    if (!userId || userId.length === 0) {
      newErrors.userId = "Please select a user";
    }

    // content.forEach((item, index) => {
    //   if (!item.name.trim()) {
    //     newErrors[`name-${index}`] = "Food name is required";
    //   }
    //   if (!item.quantity.trim()) {
    //     newErrors[`quantity-${index}`] = "Quantity is required";
    //   }
    // });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = () => {
    if (validateForm()) {
      const fromDate = new Date(startDate);
      fromDate.setDate(fromDate.getDate());
      const toDate = new Date(endDate);
      toDate.setDate(toDate.getDate());
      // frame diet content
      let tempContent = [];
      const valuesSet = new Set(selectedDietTemplateOptions.map(item => item.value));

      allDietTemplate.forEach(item => {
        if (valuesSet.has(item._id)) {
          tempContent.push(item.title)
        }
      });

      if (textContent.length > 0) {
        tempContent.push(textContent)
      }
      setContent(tempContent.join(''))

      const payload = {
        startDate: moment(fromDate).format('YYYY/MM/DD'),
        endDate: moment(toDate).format('YYYY/MM/DD'),
        createdFor: userId.value,
        title,
        content: tempContent,
      };
      handleSubmit(payload);
    }
  };

  return (
    <Modal show={show} onHide={closeModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create Diet Plan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="title">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              isInvalid={!!errors.title}
            />
            <Form.Control.Feedback type="invalid">
              {errors.title}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="dateRange">
            <Row>
              <Form.Label>Date Range</Form.Label>
              <DatePicker
                selectsRange
                minDate={currentDate}
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                  setStartDate(update[0]);
                  setEndDate(update[1]);
                }}
                isClearable={true}
                placeholderText="Select date range"
                className="form-control"
              />
            </Row>
            {errors.dateRange && (
              <Form.Text className="text-danger">{errors.dateRange}</Form.Text>
            )}
          </Form.Group>

          <Form.Group controlId="userId">
            <Form.Label>Assign To</Form.Label>
            <Select
              options={allUsers}
              value={userId}
              onChange={setUserId}
              placeholder="Select Users"
              classNamePrefix="react-select"
              isInvalid={!!errors.userId}
            />
            {errors.userId && (
              <Form.Text className="text-danger">{errors.userId}</Form.Text>
            )}
          </Form.Group>

          {/* <div style={{ padding: 10 }}>
            <a href="https://wordhtml.com/" target="_blank">{'copy text convert to html here and paste in below link'}</a>
            <a href="https://tools.knowledgewalls.com/online-multiline-to-single-line-converter" target="_blank">{'convert the html and paste in below text box'}</a>
          </div> */}

          <Form.Group controlId='allDietTemplate'>
            <Form.Label>Diet Template's</Form.Label>
            <Select
              isMulti
              options={allDietTemplateSelectOptions}
              value={selectedDietTemplateOptions}
              onChange={setSelectedDietTemplateOptions}
            />
          </Form.Group>

          {/* <Form.Group controlId='textContent'>
            <Form.Label>Diet Content</Form.Label>
            <Form.Control as="textarea"
              type='text'
              rows={5}
              placeholder='Enter diet content'
              value={textContent}
              onChange={(e) => setTextContent(e.target.value)}
            />
          </Form.Group> */}

          {/* selectedDietTemplateOptions */}

        </Form>
      </Modal.Body>
      <Modal.Footer className="flex-column">
        <Button variant="secondary" onClick={closeModal}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSubmit}>
          Create
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DietPlanModal;
